import { render } from "./Auth.vue?vue&type=template&id=0f6ca607"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Auth.vue?vue&type=style&index=0&id=0f6ca607&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script